import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueFuse from 'vue-fuse'
import { Auth0Plugin } from './plugins/auth'
import { domain, clientId, audience } from '../auth_config.json'
import { RawLocation } from 'vue-router'

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: (appState: { targetUrl: RawLocation }) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    )
  }
})
Vue.config.productionTip = false

Vue.use(VueFuse)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
